module.exports = __webpack_public_path__ + "static/GriegNightCircle250.4a4d1d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/posts/img/GriegNightCircle250.png
// module id = 35
// module chunks = 79611799117203 183328146348521 213130420965792